import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useSingleResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useSingleResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedArtifactResource,
    IndirectlyVersionedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';

export const ProjectVersionPublishmentResourceSchema = IndirectlyVersionedArtifactResourceSchema.extend({
    resourceType: z.literal(ResourceType.PROJECT_VERSION_PUBLISHMENT).default(ResourceType.PROJECT_VERSION_PUBLISHMENT),
    title: z.string(),
    changelog: z.string(),
});
export const ProjectVersionPublishmentMutationResourceSchema = getMutationSchema(
    ProjectVersionPublishmentResourceSchema
);

export type ProjectVersionPublishmentResource = z.infer<typeof ProjectVersionPublishmentResourceSchema>;

export const defaultProjectVersionPublishmentResource: ProjectVersionPublishmentResource = {
    ...defaultIndirectlyVersionedArtifactResource,
    resourceType: ResourceType.PROJECT_VERSION_PUBLISHMENT,
    title: '',
    changelog: '',
};

export function useProjectVersionPublishmentActions() {
    return {
        ...useSingleResourceSingleParentedResourceAdapterActions(
            'project/project-version-publishment',
            ResourceType.PROJECT_VERSION_PUBLISHMENT,
            ProjectVersionPublishmentResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'project/project-publishment',
            ResourceType.PROJECT_VERSION_PUBLISHMENT,
            ProjectVersionPublishmentResourceSchema
        ),
    };
}
